// extracted by mini-css-extract-plugin
export default {"login":"login_login__kSz-C","logo":"login_logo__xDGd0"};